/* Wattle & Vale — Bundle & save (snippets/wv-bundle.liquid)
   - Buy 1: the normal Add to cart of the theme (colour/size from the page)
   - Buy 2/3: one colour/size row per piece; Add to cart adds all pieces at once.
     wv-cart-drawer.js then refreshes and opens the cart drawer, and Shopify applies the automatic discount. */
(function () {
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return withCommas.split('.')[0];
        case 'amount_with_comma_separator': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        default: return withCommas + '.' + parts[1];
      }
    });
  }

  function init(root) {
    if (root.__wvBundle) return;
    root.__wvBundle = true;

    var dataEl = root.querySelector('[data-wv-bundle-data]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var money = root.getAttribute('data-money');
    var formId = root.getAttribute('data-form');
    var tiers = [].slice.call(root.querySelectorAll('.wv-bundle__tier'));
    var errorEl = root.querySelector('.wv-bundle__error');

    function byId(id) {
      for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === id) return data.variants[i];
      return null;
    }
    function byOptions(values) {
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].options.join('\u0001') === values.join('\u0001')) return data.variants[i];
      }
      return null;
    }

    var pageVariant = byId(data.current) || data.variants[0];
    var rows = []; /* chosen variant per piece for the active tier */
    var activeQty = parseInt(root.getAttribute('data-default'), 10) || 1;

    function compareOf(v) { return Math.max(v.compare || 0, v.price); }

    function tierFigures(tier) {
      var qty = +tier.getAttribute('data-qty');
      var free = +tier.getAttribute('data-free') || 0;
      var list = [];
      for (var i = 0; i < qty; i++) list.push(qty === activeQty && rows[i] ? rows[i] : pageVariant);
      var full = 0, strike = 0;
      list.forEach(function (v) { full += v.price; strike += compareOf(v); });
      /* Shopify gives the cheapest pieces for free */
      var off = list.map(function (v) { return v.price; }).sort(function (a, b) { return a - b; })
        .slice(0, free).reduce(function (a, b) { return a + b; }, 0);
      return { total: full - off, strike: strike, off: off };
    }

    function renderPrices() {
      tiers.forEach(function (tier) {
        var f = tierFigures(tier);
        tier.querySelector('[data-total]').textContent = formatMoney(f.total, money);
        var s = tier.querySelector('[data-strike]');
        s.textContent = formatMoney(f.strike, money);
        s.hidden = f.strike <= f.total;
        var save = tier.querySelector('[data-save]');
        if (save) save.textContent = formatMoney(f.off, money);
      });
    }

    /* Option values a shopper can still pick, given the other choices in that row */
    function refreshRow(rowEl, index) {
      var variant = rows[index];
      var selects = [].slice.call(rowEl.querySelectorAll('select'));
      selects.forEach(function (select, optIndex) {
        [].slice.call(select.options).forEach(function (opt) {
          var values = variant.options.slice();
          values[optIndex] = opt.value;
          var match = byOptions(values);
          var ok = !!(match && match.available);
          opt.textContent = opt.value + (ok ? '' : ' – sold out');
        });
        select.value = variant.options[optIndex];
      });
      var img = rowEl.querySelector('img');
      if (img) img.src = variant.image || data.image || '';
      var bad = !variant.available;
      rowEl.classList.toggle('is-unavailable', bad);
      var msg = rowEl.querySelector('.wv-bundle__row-msg');
      if (msg) msg.hidden = !bad;
    }

    function buildRows(tier) {
      var holder = tier.querySelector('[data-rows]');
      if (!holder) return;
      var qty = +tier.getAttribute('data-qty');
      holder.innerHTML = '';
      for (var i = 0; i < qty; i++) {
        var row = document.createElement('div');
        row.className = 'wv-bundle__row';
        var html = '<span class="wv-bundle__num">' + (i + 1) + '</span>' +
          '<span class="wv-bundle__thumbwrap"><img class="wv-bundle__thumb" alt="" width="44" height="54" loading="lazy">' +
          (i >= qty - (+tier.getAttribute('data-free') || 0) ? '<span class="wv-bundle__freetag">Free</span>' : '') + '</span>' +
          '<div class="wv-bundle__selects">';
        data.options.forEach(function (name, optIndex) {
          var seen = {};
          var single = data.variants.every(function (v) { return v.options[optIndex] === data.variants[0].options[optIndex]; });
          html += '<select' + (single ? ' hidden' : '') + ' class="wv-bundle__select" aria-label="' + name.replace(/"/g, '&quot;') + ' ' + (i + 1) + '" data-opt="' + optIndex + '">';
          data.variants.forEach(function (v) {
            var val = v.options[optIndex];
            if (seen[val]) return;
            seen[val] = true;
            var safe = String(val).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
            html += '<option value="' + safe + '">' + safe + '</option>';
          });
          html += '</select>';
        });
        html += '</div><p class="wv-bundle__row-msg" hidden>Sold out, please pick another size or colour</p>';
        row.innerHTML = html;
        if (data.options.length === 1 && data.options[0] === 'Title') row.querySelector('.wv-bundle__selects').hidden = true;
        (function (rowEl, index) {
          rowEl.addEventListener('change', function (e) {
            var select = e.target.closest('select');
            if (!select) return;
            var values = rows[index].options.slice();
            values[+select.getAttribute('data-opt')] = select.value;
            var match = byOptions(values);
            if (!match) {
              /* combination does not exist: take the first variant with this value */
              for (var k = 0; k < data.variants.length; k++) {
                if (data.variants[k].options[+select.getAttribute('data-opt')] === select.value) { match = data.variants[k]; break; }
              }
            }
            if (match) rows[index] = match;
            refreshRow(rowEl, index);
            renderPrices();
            hideError();
          });
        })(row, i);
        holder.appendChild(row);
        refreshRow(row, i);
      }
    }

    function select(tier, focus) {
      var qty = +tier.getAttribute('data-qty');
      var previous = rows.slice();
      activeQty = qty;
      rows = [];
      for (var i = 0; i < qty; i++) rows.push(previous[i] || pageVariant);
      tiers.forEach(function (t) {
        var on = t === tier;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-checked', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var holder = t.querySelector('[data-rows]');
        if (holder) holder.hidden = !on;
      });
      buildRows(tier);
      renderPrices();
      hideError();
      if (focus) tier.focus();
    }

    tiers.forEach(function (tier, index) {
      tier.addEventListener('click', function (e) {
        if (e.target.closest('select, .wv-bundle__rows')) return;
        if (!tier.classList.contains('is-active')) select(tier);
      });
      tier.addEventListener('keydown', function (e) {
        if (e.target !== tier) return;
        var next = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = tiers[(index + 1) % tiers.length];
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = tiers[(index - 1 + tiers.length) % tiers.length];
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(tier); return; }
        if (next) { e.preventDefault(); select(next, true); }
      });
    });

    /* Colour/size chosen at the top of the page: follow it for piece 1 and the prices */
    var form = document.getElementById(formId);
    if (form) {
      form.addEventListener('variant:change', function (e) {
        var v = e.detail && e.detail.variant && byId(e.detail.variant.id);
        if (!v) return;
        pageVariant = v;
        if (rows.length) {
          rows[0] = v;
          var active = root.querySelector('.wv-bundle__tier.is-active [data-rows]');
          var firstRow = active && active.querySelector('.wv-bundle__row');
          if (firstRow) refreshRow(firstRow, 0);
        }
        renderPrices();
      });
    }

    function showError(text) {
      errorEl.textContent = text;
      errorEl.hidden = false;
    }
    function hideError() { errorEl.hidden = true; }

    /* Add to cart with Buy 2/3: add every piece in one go (capture phase, before the theme's own handler) */
    document.addEventListener('submit', function (e) {
      if (!e.target || !e.target.getAttribute || e.target.getAttribute('id') !== formId || activeQty < 2) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      for (var i = 0; i < rows.length; i++) {
        if (!rows[i].available) { showError('Piece ' + (i + 1) + ' is sold out in that size or colour. Please pick another one.'); return; }
      }

      var counts = {}, order = [];
      rows.forEach(function (v) {
        if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); }
        counts[v.id]++;
      });
      var items = order.map(function (id) { return { id: id, quantity: counts[id] }; });

      var button = e.target.querySelector('button[type="submit"]');
      if (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }
      hideError();

      var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(routes + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok) showError(res.body.description || res.body.message || 'Something went wrong. Please try again.');
        })
        .catch(function () { showError('Something went wrong. Please try again.'); })
        .then(function () {
          if (button) { button.removeAttribute('aria-busy'); button.disabled = false; }
        });
    }, true);

    var start = null;
    tiers.forEach(function (t) { if (+t.getAttribute('data-qty') === activeQty) start = t; });
    select(start || tiers[0]);
  }

  function run() { [].slice.call(document.querySelectorAll('.wv-bundle')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
